// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iWKe","question":"styles_question__gWQVr","description":"styles_description__2ssZc"};